import { Color } from '@diritto/common/style/color';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const ProgressBar = ({
  progress,
  backgroundColor,
  color,
  className,
}: {
  progress: number;
  color: Color;
  backgroundColor: Color;
  className?: string;
}) => (
  <StyledProgressBarContainer className={className} color={backgroundColor}>
    <StyledProgressBar progress={progress} color={color} />
  </StyledProgressBarContainer>
);

const StyledProgressBarContainer = styled.div(
  ({ color }: { color: string }) => css`
    background-color: ${color};
    width: 100%;
    height: 100%;
  `,
);
const StyledProgressBar = styled.div(
  ({ color, progress }: { color: string; progress: number }) => css`
    background-color: ${color};
    width: ${progress}%;
    height: 100%;
  `,
);
